import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import MessageGrid from '../purchaseRequisition/messageGrid';
import ItemGridGRN from '../Goods&Receipt/grnList/itemGrid';
import { toast } from 'react-toastify';
import AuthorizationGrn from '../Goods&Receipt/authorization';
import { useLocation, useNavigate } from 'react-router-dom';
import ApiService from '../../services/apiService';
import DirectPurchaseGrid from './directPurchaseGrid';
import { RiRefreshLine } from "react-icons/ri";
import { FaAngleLeft } from "react-icons/fa6";
import { FaSave } from "react-icons/fa";
import { useSelector } from 'react-redux';
import { getCompany, getName, getUserId, getUserName } from '../../../Redux/selecters';
import DirectPurchaseUpGrid from './updateGrid';
import { ClipLoader } from 'react-spinners';
import { useCurrency } from '../../../INVENTORY/Layouts/currencyContext';
import UpdateAttachment from '../Attachment/UpdateAttachment';

const createEmptyRow = () => ({
    id: Date.now() + Math.random(),
    file: null,
    fileName: "",
    remarks: "",
});
const UpdateDirectPurchase = () => {
    const [activeTab, setActiveTab] = useState(0);
    const [gridVisibility, setGridVisibility] = useState([true, false, false]);
    const apiService = new ApiService();
    const { currencyPrecision } = useCurrency();
    const [messageData, setMessageData] = useState([]);
    const [authorizationData, setAuthorizationData] = useState([]);
    const [ItemData, setItemData] = useState([]);
    const [POData, setPOData] = useState([]);
    const [supplier, setSupplier] = useState([]);
    const [usersDetails, setUser] = useState([]);
    const [Department, setDepartment] = useState([]);
    const [WareHouse, setWareHouse] = useState([]);
    const [currency, setCurrency] = useState([]);
    const [SelectedCurrency, setSelectedCurency] = useState([]);
    const location = useLocation();
    const [supplierCheck, setSupplierCheck] = useState("Supplier");
    const currentDatetimeUTC = new Date().toISOString().slice(0, 16);
    const [SupplierTab, setSupplierTab] = useState(false);
    const [POTab, setPOTab] = useState(true);
    const [CostTab, setCostTab] = useState(false);
    const [isVatExcluded, setIsVatExcluded] = useState(false);
    const userId = useSelector(getUserId);
    const userName = useSelector(getUserName);
    const Company = useSelector(getCompany);
    const compareData = location.state;
    const [loader, setLoader] = useState(false);
    const navigate = useNavigate();
    const [cost1, setCost1] = useState([]);
    const [cost2, setCost2] = useState([]);
    const [cost3, setCost3] = useState([]);
    const [cost4, setCost4] = useState([]);
    const [LazyLoading, setLazyLoading] = useState(true);

    // Attachment
    const [attachmentModal, setAttachmentModal] = useState(false);
    const [previewModal, setPreviewModal] = useState(false);
    const [previewImage, setPreviewImage] = useState(null);
    const [preview, setPreview] = useState();
    const [attachments, setAttachments] = useState([createEmptyRow()]);
    const closeModal = () => setAttachmentModal(false);
    const handleOpen = () => setAttachmentModal(true);

    const [OtherTab, setOtherTab] = useState(false);
    const formatDateToDatetimeLocal = (dateString) => {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        return `${year}-${month}-${day}T${hours}:${minutes}`;
    };
    const getCurrentLocalDatetime = () => {
        const localDate = new Date();
        const offset = localDate.getTimezoneOffset() * 60000;
        const localISOTime = new Date(localDate - offset).toISOString().slice(0, 16);
        return localISOTime;
    };
    useEffect(() => {
        const item = location.state;
        setLazyLoading(true);

        if (item.docno) {
            const getGrn = async () => {

                try {
                    const response = await apiService.get('GET_GRN');
                    const selectedGrn = response.data.result?.find(rec => rec.grnNo === item.docno)
                    const selectedDepartment = Department?.find(dep => dep?.description === selectedGrn?.department)
                    const selectedLocation = WareHouse?.find(dep => dep?.description === selectedGrn?.warehouse)
                    const SelectedSupplier = supplier?.find(dep => dep?.supplierName === selectedGrn?.vendorName)
                    const formattedInvDate = selectedGrn?.invoiceDate ? formatDateToDatetimeLocal(selectedGrn?.invoiceDate) : getCurrentLocalDatetime();
                    const formattedDelivDate = selectedGrn?.delivery_Date ? formatDateToDatetimeLocal(selectedGrn?.delivery_Date) : getCurrentLocalDatetime();
                    setFormData({
                        GRNNO: selectedGrn?.grnNo,
                        deliveryNote: "",
                        remarks: selectedGrn?.remarks,
                        InvoiceNo: selectedGrn?.invoiceNo,
                        InvoiceDate: formattedInvDate,
                        deliveryNote: selectedGrn?.invoiceRef,
                        deliveryDate: formattedDelivDate,
                        PropertyGroup: selectedGrn?.costCenter1,
                        TaxInvoice: selectedGrn?.batchNo,
                        Property: selectedGrn?.costCenter2,
                        Outlet: selectedGrn?.costCenter3,
                        Currency: selectedGrn?.currencyCode,
                        exchangeRate: SelectedCurrency?.value?.conversionRate,
                        Department: { label: selectedDepartment?.description, value: selectedDepartment },
                        location: { label: selectedLocation?.description, value: selectedLocation },
                        vendorName: { label: SelectedSupplier?.supplierName, value: SelectedSupplier },
                        vendorId: { label: SelectedSupplier?.supplier_ID, value: SelectedSupplier },
                    });
                    setIsVatExcluded(selectedGrn.vatInclusive === true ? false : true)
                    setSupplierCheck(selectedGrn?.transporter)
                    setPOData(selectedGrn)
                    let attachparam = `?DocNo=${selectedGrn?.grnNo}&DocType=${"DirectPurchase"}`;
                    const AttachmentResponse = await apiService.getApiParamater("GET_ATTACHMENT", attachparam);
                    const existingAttachments = AttachmentResponse?.data?.result || [];
                    if (existingAttachments) {
                        setAttachments(mapAttachmentsFromApi(existingAttachments));
                    }
                    setLazyLoading(false);
                } catch (error) {
                    setLazyLoading(false);
                    console.error('Error fetching data:', error);
                }
            };
            getGrn()
        } else {
            setLazyLoading(true);
            const selectedDepartment = Department?.find(dep => dep?.description === item?.department)
            const selectedLocation = WareHouse?.find(dep => dep?.description === item?.warehouse)
            const SelectedSupplier = supplier?.find(dep => dep?.supplierName === item?.vendorName)
            const formattedInvDate = item?.invoiceDate ? formatDateToDatetimeLocal(item?.invoiceDate) : getCurrentLocalDatetime();
            const formattedDelivDate = item?.delivery_Date ? formatDateToDatetimeLocal(item?.delivery_Date) : getCurrentLocalDatetime();
            setFormData({
                GRNNO: item?.grnNo,
                deliveryNote: "",
                remarks: item?.remarks,
                InvoiceNo: item?.invoiceNo,
                InvoiceDate: formattedInvDate,
                deliveryDate: formattedDelivDate,
                deliveryNote: item?.invoiceRef,
                TaxInvoice: item?.batchNo,
                Currency: item?.currencyCode,
                costCenter1: { label: item?.costCenter1, value: item?.costCenter1 },
                costCenter2: { label: item?.costCenter2, value: item?.costCenter2 },
                costCenter3: { label: item?.costCenter3, value: item?.costCenter3 },
                costCenter4: { label: item?.costCenter4, value: item?.costCenter4 },
                exchangeRate: SelectedCurrency?.value?.conversionRate,
                Department: { label: selectedDepartment?.description, value: selectedDepartment },
                location: { label: selectedLocation?.description, value: selectedLocation },
                vendorName: { label: SelectedSupplier?.supplierName, value: SelectedSupplier },
                vendorId: { label: SelectedSupplier?.supplier_ID, value: SelectedSupplier },
            });
            setIsVatExcluded(item.vatInclusive === true ? false : true)
            setPOData(item)
            setSupplierCheck(item?.transporter)
            const getAttachment = async () => {
                let attachparam = `?DocNo=${item?.grnNo}&DocType=${"DirectPurchase"}`;
                const AttachmentResponse = await apiService.getApiParamater("GET_ATTACHMENT", attachparam);
                const existingAttachments = AttachmentResponse?.data?.result || [];
                if (existingAttachments) {
                    setAttachments(mapAttachmentsFromApi(existingAttachments));
                }

            };
            getAttachment()
            setLazyLoading(false);
        }
    }, [location?.state, Department, WareHouse, supplier]);


    const mapAttachmentsFromApi = (apiData) => {
        const validFiles = apiData.filter(
            a => a.fileName && a.fileName.trim() !== ""
        );

        return [
            ...validFiles.map(item => ({
                id: Date.now() + Math.random(), // UI id
                dbId: item.rcno,                // backend id
                file: null,                     // existing file (no File object)
                fileName: item.fileName,
                remarks: item.remarks || "",
                isNew: false,
                isDeleted: false,
            })),
            createEmptyRow()
        ];
    };

    useEffect(() => {
        fetchData()
        getApprovalUser()
        getCurrency()

    }, [])
    const handleVatChange = () => {
        setIsVatExcluded(!isVatExcluded);
    };
    let param = `?isActive=true`
    const fetchData = async () => {
        let cost1 = await apiService.get('GET_COST_ONE')
        setCost1(cost1?.data?.result)
        let cost2 = await apiService.get('GET_COST_TWO')
        setCost2(cost2?.data?.result)
        let cost3 = await apiService.get('GET_COST_THREE')
        setCost3(cost3?.data?.result)
        let cost4 = await apiService.get('GET_COST_FOUR')
        setCost4(cost4?.data?.result)
        const Supplier = await apiService.get("GET_SUPPLIER");
        setSupplier(Supplier?.data?.result);
        const department = await apiService.get("GET_DEPARTMENT_MASTER");
        setDepartment(department?.data?.result);
        // let param = `?Exp3=1`
        let WareHouse = await apiService.get('GET_WAREHOUSE_MASTER')
        setWareHouse(WareHouse?.data?.result);
    }
    const handlecurChange = (selectedOption) => {
        setFormData({ ...formData, currencyCode: selectedOption?.value?.code });
    };
    const getCurrency = async () => {
        const apiService = new ApiService()

        const currencylist = JSON.parse(localStorage.getItem('currencylist')) || [];
        const newDefaultCurrency = currencylist?.find((comp) => comp.isDefault === true);
        setSelectedCurency({ label: newDefaultCurrency.code, value: newDefaultCurrency });
        setFormData({ ...formData, exchangeRate: newDefaultCurrency.conversionRate });
    }
    const getApprovalUser = async () => {
        try {
            const apiService = new ApiService();
            const params = new URLSearchParams();
            params.append('DocNo', compareData?.grnNo);
            params.append('DocumentType', "GRN");
            const response = await apiService.getApiParamater('GET_DOC_STATUS_EDIT', `?${params.toString()}`);
            setUser(response.data.result);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const handleTabClick = (tabIndex) => {
        setActiveTab(tabIndex);
        const newGridVisibility = gridVisibility.map((_, index) => index === tabIndex);
        setGridVisibility(newGridVisibility);
    };
    const handleMessage = (data) => {
        setMessageData(data);
        console.log(data, 'reqData')

    };
    const handleRequisitionData = (data) => {
        setItemData(data);
        console.log(data, 'reqData')
    };
    const handleAuthorization = (data) => {
        setAuthorizationData(data);
        console.log(data, 'reqData')
    };
    const [formData, setFormData] = useState({
        GRNNO: "",
        deliveryNote: "",
        remarks: "",
        InvoiceNo: "",
        InvoiceDate: "",
        deliveryDate: "",
        PropertyGroup: "",
        TaxInvoice: "",
        Property: "",
        Department: "",
        Outlet: "",
        Currency: "",
        exchangeRate: SelectedCurrency?.value?.conversionRate,
        deliveryPoint: "",
        PurchaseOrderDate: "",
        contactPerson: "",
        contatNo: "",
        taskCode: "",
        email: '',
        subcatname: "",
        location: [],
        vendorName: [],
        vendorId: []
    });
    const staticOptions = [];
    const handleDepartmentChange = (selectedOption) => {
        setFormData({ ...formData, Department: selectedOption?.description });
    }
    const handleLocationChange = (selectedOption) => {
        setFormData({ ...formData, location: selectedOption });
    }
    const handleInputChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };
    const CreateGRN = async () => {
        setLoader(true)
        if (!formData.location.label) {
            toast.warning("Enter location");
            setLoader(false)
            return;
        }
        if (!formData.vendorName?.label) {
            toast.warning("Select Supplier");
            setLoader(false)
            return;
        }
        if (ItemData.length === 0) {
            toast.warning("Please add items");
            setLoader(false)
            return;
        }
        for (const item of ItemData) {
            if (!item.itemDescription) {
                toast.warning(`Please Select Item`);
                setLoader(false);
                return;
            } else if (!item.qty) {
                toast.warning(`Please enter ${item.itemDescription} quantity`);
                setLoader(false);
                return;
            } else if (!item.qty || parseFloat(item.qty) <= 0) {
                toast.warning(`${item.itemDescription} quantity must be greater than 0`);
                setLoader(false);
                return;
            } else if (!item.baseAmount || parseFloat(item.baseAmount) <= 0) {
                toast.warning(`${item.itemDescription} unit price must be greater than 0`);
                setLoader(false);
                return;
            }
        }
        const missingGL = ItemData.find(item => !item.inventoryAccountCode);
        if (missingGL) {
            toast.warning(`Please Add GL Accounts for ${missingGL?.itemDescription}`);
            setLoader(false)
            return;
        }
        const missingGRNAcc = ItemData.find(item => !item.GRNAccountCode);
        if (missingGRNAcc) {
            toast.warning(`Please Add GL Accounts for ${missingGRNAcc?.itemDescription}`);
            setLoader(false)
            return;
        }

        try {
            const totalAmount = ItemData.reduce((sum, row) => sum + (row.amount || 0), 0);
            const vatAmount = ItemData.reduce((sum, row) => sum + (row.vatAmount || 0), 0);
            const grossAmount = parseFloat(totalAmount || 0) - parseFloat(vatAmount || 0);
            const currentDatetimeUTC = new Date().toISOString();
            const GRNDetailsData = ItemData.map((item, index) => {
                const grossAmount = parseFloat(item.amount) - parseFloat(item.vatAmount || 0);
                if (item?.batchNo) {
                    if (!item?.expDate) {
                        toast.warning(`Please Select Exp Date of ${item.itemDescription}`)
                        setLoader(false)
                        return
                    }
                }
                if (item?.expDate) {
                    if (!item?.batchNo) {
                        toast.warning(`Please Enter Batch No of ${item.itemDescription}`)
                        setLoader(false)
                        return
                    }
                }
                return {
                    requisitionNo: item?.requisitionNo,
                    srno: index + 1,
                    itemCode: item?.ItemNo,
                    itemDescription: item.itemDescription,
                    uom: item.uom,
                    qty: parseInt(item.qty || 0),
                    baseUOM: item?.uom,
                    baseQty: parseInt(item.baseQty),
                    specification: item.specification,
                    convValue: parseFloat(item?.baseQty),

                    unitPrice: Number(item.baseAmount).toFixed(currencyPrecision || 3),
                    amount: Number(item.amount).toFixed(currencyPrecision || 3),
                    baseAmount: Number(item.amount).toFixed(currencyPrecision || 3),
                    convToInvUOM: parseInt(item.baseQty),
                    importedQty: 0,
                    prodDate: currentDatetimeUTC,
                    expDate: item?.expDate,
                    batchNo: item.batchNo,
                    isActive: true,
                    returnQty: 0,
                    invoicedQty: 0,
                    extraQty: 0,
                    vatBaseAmount: Number(item.vatAmount).toFixed(currencyPrecision || 3),
                    vatUnitPrice: Number(item.vatAmount / item.qty).toFixed(currencyPrecision || 3),
                    vatAmount: parseFloat(item.vatAmount),
                    grossAmount: Number(grossAmount).toFixed(currencyPrecision || 3),
                    grossBaseAmount: Number(grossAmount).toFixed(currencyPrecision || 3),
                    addCharges: parseFloat(formData.addCharges),
                    vatInclusive: isVatExcluded === true ? false : true,
                    vatCode: 1,
                    vatDesc: item.vatDes,
                    vatPerc: item.vat,
                    inventoryAccountCode: item?.inventoryAccountCode,
                    inventoryAccountName: item?.inventoryAccountName,
                }
            });

            const userData = {
                grnNo: formData.GRNNO,
                invoiceNo: formData.InvoiceNo,
                batchNo: formData.TaxInvoice,
                pOrderNo: formData.GRNNO,
                delivery_Date: formData.deliveryDate,
                status: 0,
                invoiceDate: formData.InvoiceDate,
                remarks: formData?.remarks,
                modifiedOn: currentDatetimeUTC,
                modifiedBy: userName,
                vendorId: formData.vendorId?.label.toString(),
                vendorName: formData.vendorName?.label,
                terms: formData.vendorName.value.paymentTerm,
                department: formData?.Department?.label,
                costCenter1: formData.costCenter1?.label,
                costCenter2: formData.costCenter2?.label,
                costCenter3: formData.costCenter3?.label,
                costCenter4: formData.costCenter4?.label,
                isActive: true,
                currencyCode: SelectedCurrency.label,
                exchangeRate: SelectedCurrency?.value.conversionRate,
                grnDetailsDtos: GRNDetailsData,
                warehouse: formData?.location.label,
                transport_Mode: "Direct",
                transporter: supplierCheck,
                invoiceRef: formData.deliveryNote,
                vatInclusive: isVatExcluded === true ? false : true,
                vatAmount: parseFloat(vatAmount),
                baseAmount: parseFloat(totalAmount),
                amount: parseFloat(totalAmount),
                grossAmount: parseFloat(grossAmount),
                grossBaseAmount: parseFloat(grossAmount),
            };

            const response = await apiService.put("UPDATE_GRN", userData);
            if (response?.data?.statusCode === 201) {
                const userData2 = {
                    docType: "GRN",
                    docId: formData.GRNNO,
                    status: 0,
                };
                if (attachments) {
                    let name = "DirectPurchase"
                    let docNo = formData.GRNNO
                    handleUpload(name, docNo)
                }
                const response2 = await apiService.put("UPDATE_DOC_AUTHORIZATION_STATUS", userData2);
                const paramsGet = new URLSearchParams();
                paramsGet.append('docType', "GRN");
                paramsGet.append('docId', formData.GRNNO);
                paramsGet.append('srno', 1);
                const response3 = await apiService.getApiParamater('GET_DOC_APPROVAL_USER', `?${paramsGet.toString()}`);
                // if (response3?.data?.result.length > 0) {
                //     const toEmails = response3?.data?.result?.map(user => user.userEmail);
                //     const emailbody = {
                //         toEmails: toEmails,
                //         subject: "Direct Purchase",
                //         body: "",
                //         docNo: formData.GRNNO,
                //         srNo: 1,
                //         docType: "GRN"
                //     };
                //     const emailres = await apiService.post("DOC_APPROVAL_EMAIL_POST", emailbody);
                // }
                toast.success(`${formData.GRNNO} Updated successfully`);
                setLoader(false)
                navigate("/Inventory/DirectPurchase/List")
            }
        } catch (error) {
            setLoader(false)
            console.error("Error Creating PR:", error);
        }
    };
    const handleSupplierChange = (selectedOption) => {
        setFormData({
            ...formData,
            vendorName: { label: selectedOption.value.supplierName, value: selectedOption },
            vendorId: { label: selectedOption.value.supplier_ID, value: selectedOption },
        });
    }
    const handleSuppChange = (val) => {
        setSupplierCheck(val);
    };
    const handleBackClick = () => {
        window.history.back();
    };
    const handleCost1 = (selectedOption) => {
        setFormData({ ...formData, costCenter1: selectedOption });
    }
    const handleCost2 = (selectedOption) => {
        setFormData({ ...formData, costCenter2: selectedOption });
    }
    const handleCost3 = (selectedOption) => {
        setFormData({ ...formData, costCenter3: selectedOption });
    }
    const handleCost4 = (selectedOption) => {
        setFormData({ ...formData, costCenter4: selectedOption });
    }

    // Attachment Functions
    const handleFileSelect = (file, id) => {
        setAttachments(prev => {
            const updated = prev.map(row =>
                row.id === id
                    ? {
                        ...row,
                        file,
                        fileName: file.name,
                        isNew: true
                    }
                    : row
            );

            return [...updated, createEmptyRow()];
        });
    };
    const handleRemarkChange = (id, value) => {
        setAttachments(prev =>
            prev.map(row =>
                row.id === id ? { ...row, remarks: value } : row
            )
        );
    };
    const handleDelete = (id) => {
        setAttachments(prev =>
            prev.map(row =>
                row.id === id
                    ? { ...row, isDeleted: true }
                    : row
            )
        );
    }
    const handleView = (file) => {

        if (!file) return;
        if (file?.isNew === false) {
            setPreviewImage(file?.fileName);
        } else {
            setPreviewImage(URL.createObjectURL(file?.file));
        }
        setPreview(file)
        setPreviewModal(true);
    };
    const handleUpload = async (name, docNo) => {
        const formData = new FormData();
        attachments.forEach(({ file }) => {
            if (file instanceof File) {
                formData.append("Images", file, file.name);
            }
        });

        const response = await apiService.postMultiPart(
            "UPLOAD_FILE",
            formData
        );

        if (response?.data?.statusCode === 201 && response?.data?.isSuccessful) {

            const uploadedFileNames = response.data.result.split(",");
            let uploadedIndex = 0;

            const payload = {
                docFilesDtos: attachments
                    .filter(a => {
                        //  skip deleted
                        if (a.isDeleted === true) return false;

                        //  keep old files
                        if (a.fileName && a.fileName.trim()) return true;

                        //  keep new uploads only if file exists
                        if (a.isNew && a.file) return true;

                        //  skip empty rows
                        return false;
                    })
                    .map((a, index) => {

                        let fileName = a.fileName?.trim();

                        // 🔁 Assign uploaded filename ONLY to new attachments
                        if (!fileName && a.isNew) {
                            fileName = uploadedFileNames[uploadedIndex]?.trim();
                            uploadedIndex++;
                        }
                        return {
                            rcno: a?.dbId,
                            srno: index + 1,
                            docNo: docNo,
                            docType: name,
                            fileName,
                            remarks: a.remarks || "",
                        };
                    }),
                docNo: docNo,
            };

            await apiService.put("UPDATE_ATTACHMENT", payload);
        }

    };
    return (
        <div className='px-4'>
            {LazyLoading && (
                <div
                    style={{
                        position: 'absolute',
                        inset: 0,
                        background: 'rgba(255,255,255,0.6)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 10,
                    }}
                >
                    <div className="spinner-border text-primary" role="status" />
                </div>
            )}
            <div className='d-flex justify-content-between pt-3'>
                <h5 className='col mainInvHead'>Direct Purchase</h5>
                <div className='d-flex gap-3'>
                    {loader === true ?
                        <button className='mainbtn ' type="submit"><ClipLoader color="#ffffff" size={25} /></button> :
                        <button className='mainbtn ' type="submit" onClick={CreateGRN}><FaSave className='center mt-1 mx-2' /><div>Update</div></button>
                    }
                    <button onClick={handleBackClick} className='mainbtn'><FaAngleLeft className='center mt-1 mx-2' /><div>Back</div></button>
                </div>
            </div>
            <div className="cost-center-section">
                <div className="d-flex mt-3 cursor-pointer slide-header"
                    onClick={() => setPOTab(!POTab)}>
                    <div className='h6 pt-1'>Purchase Details</div>
                </div>
                <div className={`slide-content ${POTab ? 'open' : 'closed'}`}>
                    <div className={`border-box2 p-3 ${POTab ? 'slide-in' : 'slide-out'}`}>
                        <div className="form-group row pb-3">
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="GRNNO" className="form-label  pt-2 start">DP GRN No</label>
                                <input
                                    className="form-Input w-100"
                                    value={formData.GRNNO}
                                    onChange={handleInputChange}
                                    disabled
                                />
                            </div>
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="catcode" className="form-label  pt-2 start">GRN Date</label>
                                <input className='form-Input w-100' type='datetime-local'
                                    name="deliveryDate"
                                    value={formData.deliveryDate}
                                    onChange={handleInputChange}
                                    disabled={compareData.eye === true ? true : false}
                                />
                            </div>
                            <div className='col center'>
                                <button className='mainbtn ' >Advance Search</button>
                            </div>
                        </div>
                        <div className="form-group row pb-3">
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="InvoiceNo" className="form-label  pt-2 start">Invoice No</label>
                                <input
                                    type="text"
                                    className="form-Input w-100"
                                    id="InvoiceNo"
                                    value={formData.InvoiceNo}
                                    disabled={compareData.eye === true ? true : false}
                                    onChange={handleInputChange}
                                    name="InvoiceNo"
                                />
                            </div>
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="InvoiceDate" className="form-label  pt-2 start">Invoice Date</label>
                                <input
                                    type='datetime-local'
                                    className="form-Input w-100"
                                    id="InvoiceDate"
                                    value={formData.InvoiceDate}
                                    onChange={handleInputChange}
                                    disabled={compareData.eye === true ? true : false}
                                    name="InvoiceDate"
                                />
                            </div>
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="itemCode" className="form-label  pt-2 start">Item No</label>
                                <input type='text'
                                    className="form-Input w-100" name='itemCode'
                                    value={formData.itemCode}
                                    disabled={compareData.eye === true ? true : false}
                                    onChange={handleInputChange}
                                />
                            </div>
                        </div>
                        <div className="form-group row pb-3">
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="TaxInvoice" className="form-label  pt-2 start">Tax Invoice No ( KRA )</label>
                                <input
                                    type="number" onWheel={(e) => e.target.blur()}
                                    className="form-Input w-100"
                                    id="TaxInvoice"
                                    value={formData.TaxInvoice}
                                    disabled={compareData.eye === true ? true : false}
                                    onChange={handleInputChange}
                                    name="TaxInvoice"
                                />
                            </div>
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="deliveryNote" className="form-label  pt-2 start">Delivery Note No</label>
                                <input
                                    type="text"
                                    className="form-Input w-100"
                                    id="deliveryNote"
                                    disabled={compareData.eye === true ? true : false}
                                    value={formData.deliveryNote}
                                    onChange={handleInputChange}
                                    name="deliveryNote"
                                />
                            </div>
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="catcode" className="form-label  pt-2 start">Item Description</label>
                                <input className='form-Input w-100' type='text'
                                    name="itemDescription"
                                    value={formData.itemDescription}
                                    disabled={compareData.eye === true ? true : false}
                                    onChange={handleInputChange}
                                />
                            </div>
                        </div>
                        <div className="form-group row pb-3">
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="PropertyGroup" className="form-label  pt-2 start">Delivery Type</label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    className="w-100 p-0"
                                    isDisabled={compareData.eye === true ? true : false}
                                    options={staticOptions}
                                    onChange={(selectedOption) => handleInputChange('PropertyGroup', selectedOption)}
                                />
                            </div>
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="Location" className="form-label  pt-2 start">Location</label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    className="w-100 p-0"
                                    value={formData.location}
                                    isDisabled={compareData.eye === true ? true : false}
                                    onChange={handleLocationChange}
                                    options={WareHouse?.map((sup) => ({ value: sup, label: sup?.description }))}
                                />
                            </div>
                            <div className="col">
                                <div className="d-flex p-1 brderbox gap-2 justify-content-around " style={{ background: "#d9d9d95e" }}>
                                    <div className="form-check gap-3 center">
                                        <input style={{ width: "20px", height: "20px" }}
                                            disabled={compareData.eye === true ? true : false}
                                            onClick={() => handleSuppChange("Supplier")} checked={supplierCheck === "Supplier" ? true : false}
                                            className="form-check-input" type="radio" name="flexRadioDefault" id={supplierCheck} />
                                        <label className="form-check-label" for="Supplier">Supplier</label>
                                    </div>
                                    <div className="form-check gap-3 center" >
                                        <input className="form-check-input" style={{ width: "20px", height: "20px" }}
                                            disabled={compareData.eye === true ? true : false}
                                            type="radio" name="flexRadioDefault" id={supplierCheck} checked={supplierCheck === "Cash" ? true : false}
                                            onClick={() => handleSuppChange("Cash")}
                                        />
                                        <label className="form-check-label" for="Cash">Cash Purchase</label>
                                    </div>
                                    <div className="form-check gap-3 center" >
                                        <input className="form-check-input" style={{ width: "20px", height: "20px" }}
                                            disabled={compareData.eye === true ? true : false}
                                            type="radio" name="flexRadioDefault" id={supplierCheck} checked={supplierCheck === "Sample" ? true : false}
                                            onClick={() => handleSuppChange("Sample")}
                                        />
                                        <label className="form-check-label" for="Sample">sample</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="form-group row">
                            <div className="d-flex justify-content-between col-4">
                                <label htmlFor="Outlet" className="form-label  pt-2 start">Add Charges</label>
                                <input
                                    type="text"
                                    className="form-Input w-100"
                                    id="Outlet"
                                    disabled={compareData.eye === true ? true : false}
                                    value={formData.Outlet}
                                    onChange={handleInputChange}
                                    name="Outlet"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="cost-center-section">
                <div className="d-flex mt-3 cursor-pointer slide-header"
                    onClick={() => setSupplierTab(!SupplierTab)}>
                    <div className='h6 pt-1'>Supplier Details</div>
                </div>
                <div className={`slide-content ${SupplierTab ? 'open' : 'closed'}`}>
                    <div className="border-box2 p-3">
                        <div className="form-group row">
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="inventoryAccountCode" className="form-label  pt-2 start">Supplier</label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    className="w-100 p-0"
                                    isDisabled={compareData.eye === true ? true : false}
                                    value={formData.vendorName}
                                    onChange={(selectedOption) => handleSupplierChange(selectedOption)}
                                    options={supplier?.map((sup) => ({ value: sup, label: sup?.supplierName }))}
                                />
                            </div>
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="inventoryAccountCode" className="form-label  pt-2 start">Supplier ID</label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    className="w-100 p-0"
                                    isDisabled={compareData.eye === true ? true : false}
                                    value={formData.vendorId}
                                    onChange={(selectedOption) => handleSupplierChange(selectedOption)}
                                    options={supplier?.map((sup) => ({ value: sup, label: sup?.supplier_ID }))}
                                />
                            </div>
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="Currency" className="form-label  pt-2 start">Currency </label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    className="w-100 p-0"
                                    isSearchable={false}
                                    isDisabled={compareData.eye === true ? true : false}
                                    value={SelectedCurrency}
                                    onChange={(e) => handlecurChange(e)}
                                />
                            </div>
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="ExchangeRate" className="form-label  pt-2 start">Exchange Rate </label>
                                <input
                                    type="number"
                                    className="form-Input w-100"
                                    disabled
                                    onWheel={(e) => e.target.blur()}
                                    isDisabled={compareData.eye === true ? true : false}
                                    id="exchangeRate"
                                    value={SelectedCurrency?.value?.conversionRate}
                                    onChange={handleInputChange}
                                    name="exchangeRate"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="cost-center-section">
                <div className="d-flex mt-3 cursor-pointer slide-header" onClick={() => setCostTab(!CostTab)}>
                    <div className="h6 pt-1">Cost Center Details</div>
                </div>
                <div className={`slide-content ${CostTab ? 'open' : 'closed'}`}>
                    <div className="border-box2 p-3">
                        <div className="form-group row">
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="PropertyGroup" className="form-label  pt-2 start">Property</label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    isDisabled={compareData.eye === true ? true : false}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    className="w-100 p-0"
                                    value={formData.costCenter1}
                                    onChange={handleCost1}
                                    options={cost1?.map((sup) => ({ value: sup, label: sup?.description }))}
                                />
                            </div>
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="Property" className="form-label  pt-2 start">Unit</label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    className="w-100 p-0"
                                    value={formData.costCenter2}
                                    onChange={handleCost2}
                                    options={cost2?.map((sup) => ({ value: sup, label: sup?.description }))}
                                />
                            </div>
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="Department" className="form-label  pt-2 start">Cost Center 3</label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    className="w-100 p-0" value={formData.costCenter3}
                                    onChange={handleCost3}
                                    options={cost3?.map((sup) => ({ value: sup, label: sup?.description }))}
                                />
                            </div>
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="Department" className="form-label  pt-2 start">Cost Center 4</label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    className="w-100 p-0" value={formData.costCenter4}
                                    onChange={handleCost4}
                                    options={cost4?.map((sup) => ({ value: sup, label: sup?.description }))}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="cost-center-section">
                <div className="d-flex mt-3 cursor-pointer slide-header" onClick={() => setOtherTab(!OtherTab)}>
                    <div className="h6 pt-1">Other Details</div>
                </div>
                <div className={`slide-content ${OtherTab ? 'open' : 'closed'}`}>
                    <div className="border-box2 p-3">
                        <div className='d-flex justify-content-between '>
                            <div className="d-flex justify-content-between col-md-4">
                                <label htmlFor="subcatname" className="form-label  pt-2 start">Remarks</label>
                                <input
                                    name="remarks"
                                    type='text'
                                    className="form-Input w-100"
                                    id="subcatname"
                                    disabled={compareData.eye === true ? true : false}
                                    value={formData.remarks}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div className="col-2 brderbox center" onClick={() => handleOpen()} >
                                {'Attachment'}
                            </div>
                            <div className="col-md-3 d-flex gap-2 justify-content-around">
                                <div className="form-check">
                                    <input
                                        style={{ width: "26px", height: "26px" }}
                                        type="checkbox"
                                        className="form-check-input"
                                        checked={isVatExcluded}
                                        disabled={compareData?.eye === true ? true : false}
                                        onChange={handleVatChange}
                                    />
                                    <label className="form-check-label mx-2 mt-1">
                                        Vat Excluded
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="slide-container p-2 mt-3">
                <div className="container-fluid">
                    <div className="nav nav-pills overslid d-flex gap-4">
                        {/* Nav tabs */}
                        <div
                            className={`dashitems sidebar-text center ${activeTab === 0 ? 'sideActive' : ''}`}
                            onClick={() => handleTabClick(0)}
                        >
                            Items
                        </div>
                        <div
                            className={`dashitems sidebar-text center  ${activeTab === 1 ? 'sideActive' : ''}`}
                            onClick={() => handleTabClick(1)}
                        >
                            Authorization
                        </div>
                        <div
                            className={`dashitems sidebar-text center  ${activeTab === 2 ? 'sideActive' : ''}`}
                            onClick={() => handleTabClick(2)}
                        >
                            Message
                        </div>
                    </div>

                </div>
            </div>
            <div className="grid-1 brderbox2 p-2 mb-3">
                {gridVisibility[0] && (
                    <DirectPurchaseUpGrid onRequisitionData={handleRequisitionData} itemData={POData || compareData}
                        selectedCheck={isVatExcluded} currencyPrecision={currencyPrecision?.exp1 || 3} />
                )}
                {gridVisibility[1] && (
                    <AuthorizationGrn handleAuthorization={handleAuthorization}
                        usersDetails={usersDetails}
                        setUser={setUser}
                        itemData={POData} />
                )}
                {gridVisibility[2] && (
                    <div className="grid-3 border">
                        <MessageGrid handleMessage={handleMessage} />
                    </div>
                )}
                {gridVisibility[3] && (
                    <ItemGridGRN onRequisitionData={handleRequisitionData} />
                )}
            </div>
            <UpdateAttachment
                open={attachmentModal}
                rows={attachments}
                documentNo={formData.GRNNO}
                readOnly={compareData?.eye}
                onView={handleView}
                onFileSelect={handleFileSelect}
                onRemarkChange={handleRemarkChange}
                onDelete={handleDelete}
                previewImage={previewImage}
                previewOpen={previewModal}
                preview={preview}
                onClose={closeModal}
                closePreview={() => setPreviewModal(false)}
            />
        </div >
    )
}

export default UpdateDirectPurchase